import { Slice } from "./dashboardLoaderSlice";

const { actions } = Slice;

export const setDashboardLoader = (queryParams: any) => (
  dispatch: (arg0: { payload: any; type: string }) => void
) => {
  
  return dispatch(actions.dashboardLoaderSet(queryParams));
};
